import React, { Component } from 'react';
import IcoPontos from '../../utils/img/ic-pontos.svg';
import RemoveItemIco from '../../utils/img/ic-excluir.svg';
import { AlternativeToggleCourse } from '../../utils/FormsComponents';
import { MuiThemeProvider } from 'material-ui/styles';
import { browserHistory } from 'react-router';

require('./card.css');

class CardCouse extends Component {
  constructor() {
    super();
    this.state = {};

    this.redirectNewTrail = this.redirectNewTrail.bind(this);
  }

  redirectNewTrail() {
    // this.props.redirectNewTrail();
    browserHistory.push(`/trail/create?id=${this.props.id}`);
  }

  render() {
    const { trail } = this.props;
    return (
      <MuiThemeProvider>
        <div
          className={
            this.props.available ? 'corse-card-body' : 'card-body-disable'
          }
        >
          <div className="toogle-row">
            <div className="toogle-course">
              <AlternativeToggleCourse
                onToggle={this.props.changeAvailableTrail.bind(
                  this,
                  this.props.id,
                  !this.props.available
                )}
                defaultToggled={this.props.available}
              />
            </div>
          </div>
          <div className="delete-row">
            <div className="delete-course">
              <img
                onClick={this.props.deleteTrail.bind(
                  this,
                  this.props.id,
                  this.props.available
                )}
                style={{ marginLeft: '15px' }}
                src={RemoveItemIco}
                alt="remover"
              />
            </div>
          </div>
          <div
            className="row-course-info"
            onClick={() => {
              // this.props.getCurrentTrail(this.props.id);
              this.redirectNewTrail();
            }}
          >
            <img
              className="image-course"
              onMouseOver={this.setimage}
              onMouseLeave={this.removeimage}
              src={trail.image.url}
              alt="editar curso"
            />
            <span className="card-division-course" />
            <label className="title-item">
              {trail.title > 44
                ? trail.title.slice(0, 44) + '...'
                : trail.title}
            </label>
          </div>
          <div
            className="row-course-attribute"
            // onClick={this.props.editCourse.bind(
            //   this,
            //   this.props.index,
            //   this.props.typeCourse
            // )}
          >
            <label className="duration-item">
              {trail.description > 40
                ? trail.description.slice(0, 40) + '...'
                : trail.description}
            </label>
          </div>
          <div
            className="row-course-attribute"
            // onClick={this.props.editCourse.bind(
            //   this,
            //   this.props.index,
            //   this.props.typeCourse
            // )}
          >
            {/* <label className="duration-item">
              <img className="img-score" src={IcoPontos} alt="pontuação" />
              <labe className="score-item-course"></labe>
            </label> */}
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}
export default CardCouse;
